import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]

  save() {
    this.buttonTarget.click()
  }

  submit() {
    this.element.requestSubmit();
  }
}
